// FUNCTIONS
async function ajaxRenderPositions(page, pagination) {
	try {
		const formData = new FormData();
		let filter;

		if (location.pathname.indexOf('headliner') != -1) {
			filter = 'headliner';
		} else if (location.pathname.indexOf('livemusic') != -1) {
			filter = 'livemusic';
		} else if (location.pathname.indexOf('productions') != -1) {
			filter = 'productions';
		} else if (location.pathname.indexOf('tech') != -1) {
			filter = 'tech';
		}

		formData.append('action', 'ajaxRenderPositions');
		formData.append('filter', filter);
		formData.append('page', page);
		formData.append('pagination', pagination);

		const response = await fetch(adminAjax, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Failed to fetch positions.');
		} else {
			const message = await response.json();

			document.querySelector('.positions').replaceChildren();
			document.getElementById('position-pagination')?.remove();

			if (filter && paginationChangeInitialized) {
				paginationChangeInitialized = false;
			}

			if (document.getElementById('position-pagination')) {
				document.getElementById('position-pagination').insertAdjacentHTML('beforebegin', message.data);
			} else {
				document.querySelector('.positions').insertAdjacentHTML('beforeend', message.data);
			}

			document.querySelectorAll('.position').forEach((element) => {
				fadeIn(element, 800);
			});

			if (!paginationChangeInitialized && document.getElementById('position-pagination') !== null) {
				paginationChangeInitialized = true;
			}
		}
	} catch (error) {
		console.error(error);
		alert('Cannot connect to the server. Please try again later.');
	}
}

// VARIABLES
const positions = document.querySelector('.positions');

// INITIALIZATION
ajaxRenderPositions(1, true);

// EVENT LISTENERS
positions.addEventListener('change', (event) => {
	if (event.target.matches('#position-pagination')) {
		let filter;

		if (window.location.hash) {
			filter = window.location.hash.substring(1);
		} else {
			filter = false;
		}

		ajaxRenderPositions(filter, event.target.value, false);
	}
});

positions.addEventListener('click', (event) => {
	if (event.target.closest('.position h4')) {
		const arrow = event.target.querySelector('i');
		const longDescription = event.target.parentElement.querySelector('.long-description');

		if (arrow.classList.contains('icon-arrow-down')) {
			arrow.classList.replace('icon-arrow-down', 'icon-arrow-up');
			fadeIn(longDescription);
		} else {
			arrow.classList.replace('icon-arrow-up', 'icon-arrow-down');
			fadeOut(longDescription);
		}
	}
});